module.exports = __webpack_public_path__ + "static/media/consulting.910bb296.svg";